import componentFn from '../../styles/objects/component'
import breakTo from '../../styles/tools/breakTo'
import { important } from '../../styles/tools/parsers'

export default ({
  colors,
  spacings,
  images,
  fontFamilies,
  fontWeights,
  fontSizes,
  textTransforms
}) => {
  const component = componentFn({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
  })

  const styles = {
    img: {
      display: 'block',

      maxWidth: '550px',
      height: '170px',
      marginRight: important('auto'),
      marginBottom: '0',
      marginLeft: important('auto'),

      textAlign: 'center',

      [breakTo('small')]: {
        display: 'inline-block',

        width: '14rem',
        maxWidth: '100%',
        marginRight: '0',
        marginLeft: '0',
        'padding-right': '0',
        paddingLeft: '0',

        textAlign: 'inherit'
      }
    },

    pic: {
      display: 'table-cell',

      width: '7rem',

      [breakTo('small')]: {
        display: 'block',

        width: '100%'
      }
    },

    text: {
      top: '140px',
      fontWeight: fontWeights.image.default,
      fontFamily: fontFamilies.alternate,
      display: 'table-cell',

      textAlign: 'left',
      verticalAlign: 'middle',

      [breakTo('small')]: {
        display: 'block',

        width: 'inherit',

        paddingLeft: '.2rem',
        paddingRight: '.2rem',

        textAlign: 'center',
        verticalAlign: 'inherit'
      }
    },

    wyn: {
      display: 'block',

      width: '95px',
      height: '110px',
      marginRight: 'auto',
      marginLeft: 'auto',

      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain'
    },

    'wyn--docs': {
      backgroundImage: images.whatYouNeed.documents
    },

    'wyn--phone': {
      backgroundImage: images.whatYouNeed.phone
    },

    'wyn--secure': {
      backgroundImage: images.whatYouNeed.secure
    }
  }

  return { ...component, ...styles }
}



// WEBPACK FOOTER //
// ./components/image/styles.js